export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--phone.11e013ab.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};